var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBfsgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.757.099a1.865 1.865 0 0 0-1.864 1.863v28.144c0 1.027.836 1.863 1.864 1.863h20.357a1.865 1.865 0 0 0 1.862-1.863v-7.99c-.088-.453 0-16.118 0-16.118a.62.62 0 0 0-.181-.439L22.516.281a.62.62 0 0 0-.44-.182zm.206 2.07h15.093v4.204c0 .425.344.77.768.77h4.083v22.756H5.964z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.854 5.134h5.919a.76.76 0 0 0 0-1.518H8.854a.758.758 0 1 0 0 1.518m11.26 2.171a.76.76 0 0 0-.758-.758H8.885a.76.76 0 0 0 0 1.517h10.471c.42 0 .759-.34.759-.759M8.872 11.1h5.92a.759.759 0 1 0 0-1.518h-5.92a.76.76 0 0 0 0 1.518m7.08 4.456a1.863 1.863 0 1 1 1.863-1.864 1.865 1.865 0 0 1-1.863 1.864",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.807 15.582-.015.004-.013.005-.1.03c-.62.18-3.624 1.028-5.741 1.028-1.968 0-4.7-.732-5.575-.98a3 3 0 0 0-.266-.086c-.633-.167-1.065.475-1.065 1.062 0 .581.522.858 1.05 1.057v.01l3.168.989c.323.124.41.25.452.36.138.353.028 1.05-.011 1.294l-.193 1.497-1.071 5.862-.01.049-.007.042c-.077.537.318 1.059 1.065 1.059.652 0 .94-.45 1.065-1.063 0 0 .931-5.242 1.397-5.242s1.425 5.242 1.425 5.242c.125.613.413 1.063 1.065 1.063.75 0 1.144-.524 1.065-1.063a2 2 0 0 0-.026-.135l-1.085-5.813-.193-1.498c-.14-.872-.027-1.16.01-1.227l.003-.005c.036-.067.2-.216.582-.36l2.97-1.038.054-.017c.532-.2 1.065-.476 1.065-1.062s-.432-1.23-1.065-1.064",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfsgIcon);
export default __webpack_public_path__ + "static/media/BFSG_icon.6fdb676ceaf3f5d4c02e412db83219df.svg";
export { ForwardRef as ReactComponent };